
import {useState, useEffect} from 'react';
import {Dialog, IconButton} from '@material-ui/core';
import useStyles from './styles';
import CloseIcon from '@material-ui/icons/Close';
import Button from '../../../components/Base/Button';
import {iconCloseAdd} from '../../../assets/icons';
import { inviteMembers, inviteCustomer } from 'actions/customer';
import { useDispatch, useSelector } from 'react-redux';
import { useDebounce } from 'common/hooks/useDebounce';
import { getListMembersApp } from 'actions/customer';
import { alertActions } from 'actions/alert.actions';
import { debounce } from 'lodash';

const InviteMember = (props: any) => {
  const { open, inviteGroup, idGroup, groupName, existingEmails = [] } = props;
  const styles = useStyles();
  const [list, setList] = useState<any>([]);
  const [listMembers, setListMembers] = useState<any>([]);
  const [email, setEmail] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [error, setError] = useState("");
  const [keyState, setKeyState] = useState(Math.random());
  const dispatch = useDispatch();
  const { dataInviteMembers, membersApp, dataInviteCustomer } = useSelector(
    (state: any) => state.customers
  );
  const [loading, setLoading] = useState(false);
  const debouncedSearch = useDebounce(search, 500);

  const callList = () => {
    return dispatch(
      getListMembersApp(
        idGroup,
        Object.assign(
          { page, limit },
          debouncedSearch && { search: debouncedSearch.trim() }
        )
      )
    );
  };

  const validateEmail = (emailValue: string) => {
    return String(emailValue)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  useEffect(() => {
    if (debouncedSearch) {
      callList();
      if (validateEmail(debouncedSearch) && listMembers.length === 0) {
        setEmail(debouncedSearch);
      }
    }
  }, [debouncedSearch]);

  useEffect(() => {
    if (email && !validateEmail(email)) {
      setError("Invalid email address");
    } else {
      setError("");
    }
  }, [email]);

  useEffect(() => {
    if (dataInviteMembers || dataInviteCustomer) {
      setLoading(false);
      const { onCloseModal } = props;
      setList([]);
      onCloseModal(true);
    }
  }, [dataInviteMembers, dataInviteCustomer]);

  const checkId = (data?: any) => {
    let check = false;
    list?.map((item: any) => {
      if (item?.id === data?.id) {
        check = true;
      }
    });
    return check;
  };

  const formatData = (data?: any) => {
    let newData: any = [];
    data?.map((item: any, index: any) => {
      if (!checkId(item)) {
        newData.push(item);
      }
    });
    return newData;
  };

  useEffect(() => {
    if (membersApp?.data && search) {
      setListMembers(formatData(membersApp?.data));
    }
  }, [membersApp]);

  const handleCloseModal = () => {
    const { onCloseModal } = props;
    setList([]);
    setListMembers([]);
    setEmail("");
    setSearch("");
    onCloseModal();
    setLoading(false);
  };

  const isEmailAlreadyInList = (emailToCheck: string) => {
    // Check if email is in the invitation list
    const isInInviteList = list.some((item: any) => {
      if (typeof item === "string") {
        return item === emailToCheck;
      }
      return item.email === emailToCheck;
    });

    // Check if email is in existing customers
    const isInExisting = existingEmails.includes(emailToCheck);

    return isInInviteList || isInExisting;
  };

  const handleAdd = () => {
    if (error || email === "") return;

    if (isEmailAlreadyInList(email)) {
      dispatch(
        alertActions.error(
          existingEmails.includes(email)
            ? "This user is already a customer."
            : "This user has already been added to your invitation list."
        )
      );
      return;
    }

    setEmail("");
    setSearch("");
    setKeyState(Math.random());
    setList([email, ...list]);
  };

  const onRemove = (index: number) => {
    let removeList = list;
    removeList.splice(index, 1);
    setKeyState(Math.random());
    setList(removeList);
  };

  const formatList = (dataList: any) => {
    let rs = dataList?.map((item: any) => {
      if (item?.id) {
        return {
          id: item.id,
          email: item.email,
        };
      }
      return {
        id: 0,
        email: item,
      };
    });
    return rs;
  };

  const handleSend = () => {
    if (inviteGroup) {
      if (formatList(list)?.length === 0)
        return dispatch(alertActions.error("This field is required."));
      dispatch(inviteMembers(idGroup, { users: formatList(list) }));
    } else {
      if (list?.length === 0)
        return dispatch(alertActions.error("This field is required."));
      dispatch(inviteCustomer({ emails: list }));
    }
    setLoading(true);
  };

  const handleAddMember = (itemAdd: any) => {
    if (isEmailAlreadyInList(itemAdd.email)) {
      dispatch(
        alertActions.error(
          existingEmails.includes(itemAdd.email)
            ? "This user is already a customer."
            : "This user has already been added to your invitation list."
        )
      );
      return;
    }

    setList([
      ...list,
      { email: itemAdd?.email, name: itemAdd?.full_name, id: itemAdd?.id },
    ]);
    setListMembers([]);
    setSearch("");
    setKeyState(Math.random());
  };

  return (
    <Dialog
      open={open}
      onClose={handleCloseModal}
      fullWidth={true}
      maxWidth={"lg"}
      classes={{ paper: styles.paperModal }}
      PaperProps={{
        style: { boxShadow: "none", width: "80vw" },
      }}
    >
      <div className={styles.contentModal}>
        <div className={styles.titleModal}>
          {inviteGroup
            ? `Invite member to ${groupName}`
            : "Invite members to your app"}
        </div>
        <p className={styles.subtitleModal}>
          {inviteGroup
            ? "Type in the customer's name or email you would like to join this group."
            : "Select what customers you would like to invite to your app."}
        </p>
        <IconButton
          className={styles.closeButton}
          edge="end"
          color="inherit"
          onClick={() => handleCloseModal()}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
        <div className={`${styles.contentBodyModal} d-top`}>
          <div className={styles.headTypeAdd} key={keyState}>
            {inviteGroup ? (
              <input
                className={styles.inputEmail}
                type="text"
                placeholder={"Type in customer name or email"}
                defaultValue={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            ) : (
              <input
                className={styles.inputEmail}
                type="text"
                placeholder={"Type in customer's email"}
                defaultValue={email}
                onChange={(e) => setEmail(e.target.value.trim())}
              />
            )}
            {listMembers.length > 0 && search && inviteGroup && (
              <div className={styles.resultBox}>
                <ul>
                  {listMembers?.map((item: any, index: number) => (
                    <li
                      key={index}
                      className={styles.resultText}
                      onClick={() => handleAddMember(item)}
                    >
                      <span className={styles.textNormal}>
                        {item?.full_name}
                        {item?.email ? `(${item?.email})` : ""}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <Button
              type={"button"}
              className={styles.btnAdd}
              label={"Add"}
              onClick={handleAdd}
            >
              Add
            </Button>
          </div>
          {error && <p className={styles.colorRed}>{error}</p>}
          <div className={styles.bodyTypeAdd}>
            {list?.map((item: any, index: number) => (
              <div className={styles.addItem} key={index}>
                {item?.name ? item.name : item}
                <span
                  className={styles.iconCloseAdd}
                  onClick={() => onRemove(index)}
                >
                  <img src={iconCloseAdd} alt="icon" />
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={styles.modalFooter}>
        <span onClick={handleCloseModal}>Cancel</span>
        <div className={`${styles.btnCreateNew} d-inline-block`}>
          <Button
            type={"button"}
            label={"Send"}
            disable={loading}
            onClick={debounce(handleSend, 500)}
          ></Button>
        </div>
      </div>
    </Dialog>
  );
};
export default InviteMember;
